// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"ad803aa3","776":"ad803aa3"}[chunkId] + ".chunk.css";
};